/**
 * HomePage Component
 * Landing page with main action cards
 */

import React from 'react';
import { Search, Plus, ChevronRight } from 'lucide-react';

interface HomePageProps {
  onNavigateToSearch: () => void;
  onNavigateToStartBRR: () => void;
  isActive?: boolean;
}

const HomePageComponent: React.FC<HomePageProps> = ({
  onNavigateToSearch,
  onNavigateToStartBRR,
  isActive,
}) => {

  return (
    <div className="space-y-6">
      {/* Welcome Header */}
      <div className="text-center mb-12">
        <h1 className="text-3xl font-bold text-gray-900 mb-3">Batch Record Review System</h1>
        <p className="text-lg text-gray-600">Welcome to the BRR Automation Platform</p>
      </div>

      {/* Main Action Cards */}
      <div className="max-w-4xl mx-auto grid grid-cols-2 gap-6">
        {/* Search BRR Card */}
        <button
          onClick={onNavigateToSearch}
          className="group bg-white rounded-xl border-2 border-gray-200 shadow-sm hover:shadow-lg hover:border-blue-400 transition-all p-8 text-left"
          style={{ overflow: 'visible', minHeight: 'auto', display: 'block' }}
        >
          <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mb-6 group-hover:bg-blue-200 transition-colors flex-shrink-0">
              <Search size={40} className="text-blue-600" />
            </div>
            <h2 className="text-xl font-semibold text-gray-900 mb-3" style={{ width: '100%', textAlign: 'center', whiteSpace: 'normal', wordWrap: 'break-word', overflowWrap: 'break-word' }}>
              Search Batch Record Reviews
            </h2>
            <p
              className="text-sm text-gray-600 mb-4"
              style={{
                width: '100%',
                textAlign: 'center',
                whiteSpace: 'normal',
                wordWrap: 'break-word',
                overflowWrap: 'break-word',
                wordBreak: 'break-word',
                display: 'block',
                maxWidth: '100%'
              }}
            >
              View and search existing batch record reviews, check status, and access completed BRRs
            </p>
            <div className="flex items-center gap-2 text-blue-600 font-medium flex-wrap justify-center" style={{ width: '100%', marginTop: 'auto' }}>
              <span className="whitespace-nowrap">Search Reviews</span>
              <ChevronRight size={20} className="flex-shrink-0" />
            </div>
          </div>
        </button>

        {/* Create BRR Card */}
        <button
          onClick={onNavigateToStartBRR}
          className="group bg-white rounded-xl border-2 border-gray-200 shadow-sm hover:shadow-lg hover:border-green-400 transition-all p-8 text-left"
          style={{ overflow: 'visible', minHeight: 'auto', display: 'block' }}
        >
          <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mb-6 group-hover:bg-green-200 transition-colors flex-shrink-0">
              <Plus size={40} className="text-green-600" />
            </div>
            <h2 className="text-xl font-semibold text-gray-900 mb-3" style={{ width: '100%', textAlign: 'center', whiteSpace: 'normal', wordWrap: 'break-word', overflowWrap: 'break-word' }}>
              Create Batch Record Review
            </h2>
            <p
              className="text-sm text-gray-600 mb-4"
              style={{
                width: '100%',
                textAlign: 'center',
                whiteSpace: 'normal',
                wordWrap: 'break-word',
                overflowWrap: 'break-word',
                wordBreak: 'break-word',
                display: 'block',
                maxWidth: '100%'
              }}
            >
              Start a new batch record review by uploading documentation and linking batch information
            </p>
            <div className="flex items-center gap-2 text-green-600 font-medium flex-wrap justify-center" style={{ width: '100%', marginTop: 'auto' }}>
              <span className="whitespace-nowrap">Start Batch Record Review</span>
              <ChevronRight size={20} className="flex-shrink-0" />
            </div>
          </div>
        </button>
      </div>
    </div>
  );
};

export const HomePage = React.memo(HomePageComponent);
